module.exports = __webpack_public_path__ + "media/icons/naped-tyl@3x-32b82696.svg";